__turbopack_context__.v({
  "actionButtons": "OnboardingTooltipContainer-module__NLNb3a__actionButtons",
  "actionContainer": "OnboardingTooltipContainer-module__NLNb3a__actionContainer",
  "betaChipRow": "OnboardingTooltipContainer-module__NLNb3a__betaChipRow",
  "closeButtonWrapper": "OnboardingTooltipContainer-module__NLNb3a__closeButtonWrapper",
  "contentContainer": "OnboardingTooltipContainer-module__NLNb3a__contentContainer",
  "headerIcon": "OnboardingTooltipContainer-module__NLNb3a__headerIcon",
  "headerIconRow": "OnboardingTooltipContainer-module__NLNb3a__headerIconRow",
  "headerRow": "OnboardingTooltipContainer-module__NLNb3a__headerRow",
  "highlightOverlay": "OnboardingTooltipContainer-module__NLNb3a__highlightOverlay",
  "highlightOverlayVisible": "OnboardingTooltipContainer-module__NLNb3a__highlightOverlayVisible",
  "linkButton": "OnboardingTooltipContainer-module__NLNb3a__linkButton",
  "linkIcon": "OnboardingTooltipContainer-module__NLNb3a__linkIcon",
  "media": "OnboardingTooltipContainer-module__NLNb3a__media",
  "mediaContainer": "OnboardingTooltipContainer-module__NLNb3a__mediaContainer",
  "textContent": "OnboardingTooltipContainer-module__NLNb3a__textContent",
  "tooltipContainer": "OnboardingTooltipContainer-module__NLNb3a__tooltipContainer",
});
